import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4abeeceb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-select-container" }
const _hoisted_2 = { class: "time-select-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, ":", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["BaseSelect"], {
        name: "시",
        placeholder: "",
        items: $setup.hourOptions,
        value: $setup.selectedHour,
        onOnChangeSelect: $setup.updateHour
      }, null, 8 /* PROPS */, ["items", "value"]),
      _hoisted_3,
      _createVNode($setup["BaseSelect"], {
        name: "분",
        placeholder: "",
        items: $setup.minutesOptions,
        value: $setup.selectedMinutes,
        onOnChangeSelect: $setup.updateMinutes
      }, null, 8 /* PROPS */, ["items", "value"])
    ])
  ]))
}